import { createReducer } from "@reduxjs/toolkit";
import { EDIT_CALENDAR_EVENT_SUCCESS, FETCH_CALENDAR_EVENT_SUCCESS } from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(FETCH_CALENDAR_EVENT_SUCCESS, (state, action) => {
      const { response = {}, id = 0 } = action;
      const key = `CalendarEvent-${id}`;
      const { entities = {} } = response;
      const { calendarEventParticipants } = entities;
      if (calendarEventParticipants && id) {
        state[key] = {
          ...state[key],
          ...calendarEventParticipants,
        };
      }
      return state;
    })
    .addCase(EDIT_CALENDAR_EVENT_SUCCESS, (state, action) => {
      const { response = {}, id = 0 } = action;
      const key = `CalendarEvent-${id}`;
      const { entities = {} } = response;
      const { calendarEventParticipants } = entities;
      if (calendarEventParticipants && id) {
        state[key] = calendarEventParticipants;
      }
      return state;
    });
});

export default reducer;
